module.exports = __webpack_public_path__ + "static/img/about－image－6.e716ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about－image－6.png
// module id = +uuA
// module chunks = 1